import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";

import { useAdminAuthContext } from "./administrator/admin/useAdminAuthContext";
import { AdminLogin } from "./administrator/admin/AdminLogin";
import { AdminDashboard } from "./administrator/admin/AdminDashboard";
import { AdminManage } from "./administrator/admin/AdminManage";
import { AdminCreate } from "./administrator/admin/AdminCreate";

import Landing from "./Landing";
import Home from "./user/Home";
import Dashboard from "./user/Dashboard";

import { useUserAuthContext } from "./user/useUserAuthContext";
import { AdminManageUsers } from "./administrator/user/AdminManageUsers";
import { AdminManageMasterWorkout } from "./administrator/workout/AdminManageMasterWorkout";
import { AdminBuildWorkout } from "./administrator/workout/AdminBuildWorkout";
import Response from "./workout/Response";

function App() {
  const { admin } = useAdminAuthContext();
  const { user, authReady } = useUserAuthContext();

  // ✅ Wait until localStorage is checked
  if (!authReady) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center text-zinc-700">
        Loading...
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        {/* ========================= */}
        {/* Admin related routes */}
        {/* ========================= */}
        <Route path="/administrator/login" element={<AdminLogin />} />

        <Route
          path="/administrator/dashboard"
          element={admin ? <AdminDashboard /> : <AdminLogin />}
        />



        <Route
          path="/administrator/admin/manage"
          element={admin ? <AdminManage /> : <AdminLogin />}
        />

        <Route
          path="/administrator/admin/manageusers"
          element={admin ? <AdminManageUsers /> : <AdminLogin />}
        />

        <Route
          path="/administrator/admin/managemasterworkout"
          element={admin ? <AdminManageMasterWorkout /> : <AdminLogin />}
        />

        <Route
          path="/administrator/admin/workout/build/:id"
          element={admin ? <AdminBuildWorkout /> : <AdminLogin />}
        />



        

        <Route
          path="/administrator/admin/create"
          element={admin ? <AdminCreate /> : <AdminLogin />}
        />

        {/* ========================= */}
        {/* Frontend related routes */}
        {/* ========================= */}
        <Route
          path="/"
          element={
            user ? (
              <Navigate to={"/home"} />
            ) : (
              <Landing />
            )
          }
        />

        <Route
          path="/home"
          element={user ? <Home /> : <Navigate to="/" />}
        />

        <Route
          path="/dashboard"
          element={user ? <Dashboard /> : <Navigate to="/" />}
        />

        <Route
          path="/response"
          element={<Response />}
        />




      </Routes>
    </BrowserRouter>
  );
}

export default App;
